import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Box,
  Flex,
  Badge,
  Text,
} from '@chakra-ui/react';

interface SigningLog {
  type: string;
  message: string;
  created_at: string;
}

interface SigningLogModalProps {
  isOpen: boolean;
  onClose: () => void;
  logs: SigningLog[] | undefined;
}

const SigningLogModal = ({ isOpen, onClose, logs }: SigningLogModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Signing Log</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="6">
          <VStack align="stretch" spacing="3">
            {logs?.map((log, index) => (
              <Box
                key={index}
                p="3"
                borderRadius="md"
                bg="gray.50"
                borderLeft="4px solid"
                borderLeftColor="brand.500"
              >
                <Flex justify="space-between" align="flex-start" mb="2">
                  <Badge
                    colorScheme={
                      log.type === 'error'
                        ? 'red'
                        : log.type === 'warning'
                        ? 'yellow'
                        : 'green'
                    }
                    variant="subtle"
                    fontSize="xs"
                  >
                    {log.type.toUpperCase()}
                  </Badge>
                  <Text fontSize="xs" color="gray.500">
                    {new Date(log.created_at).toLocaleString()}
                  </Text>
                </Flex>
                <Text fontSize="sm" color="gray.700">
                  {log.message}
                </Text>
              </Box>
            )) || (
              <Text fontSize="sm" color="gray.500" textAlign="center">
                No logs available
              </Text>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SigningLogModal;
